import { Config } from '../App';

export interface ConfigVersion {
  id: string;
  timestamp: number;
  name: string;
  config: Config;
}

const STORAGE_KEY = 'admin_config_versions';
const MAX_VERSIONS = 10;

export const saveConfigVersion = (
  config: Config,
  customName?: string
): void => {
  try {
    const existingVersions = getConfigVersions();
    const timestamp = Date.now();
    const name = customName || new Date(timestamp).toLocaleString();

    const newVersion: ConfigVersion = {
      id: `version_${timestamp}`,
      timestamp,
      name,
      config: JSON.parse(JSON.stringify(config)), // Deep copy
    };

    // Add new version at the beginning
    const updatedVersions = [newVersion, ...existingVersions];

    // Keep only the last MAX_VERSIONS
    const trimmedVersions = updatedVersions.slice(0, MAX_VERSIONS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedVersions));
  } catch (error) {
    console.error('Failed to save config version:', error);
  }
};

export const getConfigVersions = (): ConfigVersion[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    const versions = JSON.parse(stored) as ConfigVersion[];
    return versions.sort((a, b) => b.timestamp - a.timestamp); // Most recent first
  } catch (error) {
    console.error('Failed to load config versions:', error);
    return [];
  }
};

export const loadConfigVersion = (versionId: string): Config | null => {
  try {
    const versions = getConfigVersions();
    const version = versions.find((v) => v.id === versionId);
    return version ? JSON.parse(JSON.stringify(version.config)) : null; // Deep copy
  } catch (error) {
    console.error('Failed to load config version:', error);
    return null;
  }
};

export const deleteConfigVersion = (versionId: string): void => {
  try {
    const versions = getConfigVersions();
    const filteredVersions = versions.filter((v) => v.id !== versionId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredVersions));
  } catch (error) {
    console.error('Failed to delete config version:', error);
  }
};

export const clearAllVersions = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear config versions:', error);
  }
};
